import * as constants from "./../../constants";

/**
 * Generate avatar string - initials from the name
 * @param {*} name
 */
export const getAvatarStringFromName = (name) => {
  var avatarString = ""
  if (name) {
    avatarString = name.substring(0, 2).toUpperCase();
  }
  return avatarString;
}

const dateDiffInDays = function (date) {
  let dt1 = new Date(date);
  let dt2 = new Date();
  return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
}

/**
 *  Function to render date time in required display format for ledger
 *  @param {*} dateTimeInMillisString
 */
export const getLedgerDisplayDateTime = (dateTimeInMillisString) => {
  var responseDateString = "-";
  var responseDate = new Date();
  responseDate.setTime(Number(dateTimeInMillisString + '000'));
  let dateDiff = dateDiffInDays(Number(dateTimeInMillisString + '000'));
  if (dateDiff < 1)
    responseDateString = responseDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  else if (dateDiff == 1)
    responseDateString = "Yesterday"
  else if (dateDiff < 7)
    responseDateString = constants.WEEK_DAYS[responseDate.getDay()]
  else
    responseDateString = responseDate.getDate() + ' ' + constants.MONTHS[responseDate.getMonth()]
  return responseDateString;
}

/**
* Function to render date in format DD MMM YYYY
* @param {*} dateTimeInMillisString
*/
export const getDateInStringDDMMMYYYY = (dateTimeInMillisString) => {
  if (!dateTimeInMillisString) return '';
  var responseDate = new Date(Number(dateTimeInMillisString + '000'));
  return responseDate.getDate() + ' ' + constants.MONTHS[responseDate.getMonth()] + ' ' + responseDate.getFullYear()
}

/**
 * Function to render date in format DD MMM YYYY
 * @param {*} datePickerDate
 */
export const getDatePickerDateInStringDDMMMYYYY = (datePickerDate) => {
  if (!datePickerDate) return '';
  return datePickerDate.getDate() + ' ' + constants.MONTHS[datePickerDate.getMonth()] + ' ' + datePickerDate.getFullYear()
}

/**
 * Function to parse vehicle number
 * @param {*} vehicleNumber
 */
export const getVehicleNumberValues = (vehicleNumber) => {
  return vehicleNumber ? [vehicleNumber.substring(0, vehicleNumber.length - 4),
  vehicleNumber.substring(vehicleNumber.length - 4, vehicleNumber.length)] : ['', ''];
}

/**
* Function to parse vehicle number
* @param {*} vehicleNumber
*/
// export const getVehicleNumberValuesDWeb = (vehicleNumber) => {

//   return vehicleNumber.match(/[\d]+|[A-Z|a-z]+/g)

// }


export const getVehicleNumberValuesDWeb = (vehicleNumber) => {
  if (vehicleNumber) {
    let data = vehicleNumber.match(/[\d]+|[A-Z|a-z]+/g);
    if (data && data.length == 2) {
      /*if (data[1] && checkNumberOnly(data[1]) && data[1].length == 6) {
        let final = data[1];
        let part1 = final.substr(0, 2);
        let part2 = final.substr(2, 5);
        return [data[0], part1, part2]
      } else if (data[1] && checkNumberOnly(data[1]) && data[1].length == 5) {
        let final = data[1];
        let part1 = final.substr(0, 1);
        let part2 = final.substr(1, 4);
        return [data[0], part1, part2]
      }*/
      return [vehicleNumber, "", ""]
    }
    return data;
  }

}

export const checkNumberOnly = (string) => {
  return /^\d+(\.\d{1,3})?$/.test(string);
  //return /^\d+$/.test(string);
}


/**
* Function to get milliseconds value from date format DD MMM YYYY
* @param {*} dateString
*/
export const getTimeInMillisDDMMMYYYY = (dateString) => {
  return dateString ? ((new Date(dateString.split(" ").reverse().join("-")).getTime()) / 1000) : null;
}